import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  blik_code: 'BLIK code',
  blik_invoice__title: 'Pay with a BLIK code',
  blik_invoice__subtitle: 'Enter the 6-digit code generated in your banking app.',
  blik_invoice__code_hint: 'The code is valid for 2 minutes.',
  blik_invoice__pay_button: 'Pay {amount} {currency}',
  blik_invoice__help_link: 'Where can I get a BLIK code?',
  blik_invoice__help_text: 'Generate a BLIK code in your bank’s mobile app:',
  blik_invoice__help_step_1: 'Open your banking app.',
  blik_invoice__help_step_2: 'Choose BLIK and generate a 6-digit code.',
  blik_invoice__help_step_3: 'Enter the code above and tap Pay.',
  blik_invoice__requisites_title: 'Payment details',
  blik_invoice__waiting_title: 'Confirm the payment in your banking app',
  blik_invoice__waiting_text:
    'Open your banking app and approve the payment. Keep this page open.',
  blik_invoice__waiting_cancel: 'Cancel payment',
  blik_invoice__status_declined_title: 'Payment declined',
  blik_invoice__status_declined_text: 'Your bank did not approve the payment.',
  blik_invoice__status_declined_hint: 'Check your balance or try again using a new BLIK code.',
  blik_invoice__status_back: 'Back to merchant',
  blik_invoice__status_success_title: 'Payment successful',
  blik_invoice__status_success_text: 'The payment was approved.',
  blik_invoice__status_expired_title: 'Payment expired',
  blik_invoice__status_expired_text: 'The time to complete this payment has run out.',
  blik_invoice__confirmation_invalid:
    'Confirmation details are unavailable. Return to the merchant and try again.',
};
